/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ImportLineDtoErrorDetail } from './importLineDtoErrorDetail';

/**
 * Une ligne d'import telle que l'écran de tâche la voit : identité, état et erreurs. Les valeurs sont dans le dataFile de la page, à la même position.
 */
export interface ImportLineDto {
    rowIndex?: number;
    status?: string;
    errors?: Array<string>;
    errorDetails?: Array<ImportLineDtoErrorDetail>;
}
